import { BlankImage } from "./BlankImage";
import { Image } from "./Image";

type Props = { imageUrls: string[]; index: number };

export const Images = ({ imageUrls, index }: Props) => {
  return (
    <>
      {!imageUrls.length ? (
        <BlankImage />
      ) : (
        imageUrls.map((imageUrl, i) => (
          <Image imageUrl={imageUrl} show={index === i} key={imageUrl} />
        ))
      )}
    </>
  );
};
